'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _information = require('./information.html');

var _information2 = _interopRequireDefault(_information);

var _information3 = require('./information.controller');

var _information4 = _interopRequireDefault(_information3);

require('./information.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var informationComponent = {
  bindings: {},
  template: _information2.default,
  controller: _information4.default,
  controllerAs: "vm"
};

exports.default = informationComponent;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/information/information.component.js